<template>
  <div>
    <sw-table
      v-loading="!tab_1.ready"
      :table-name="'soft-manage'"
      :table-data="tab_1.tableData1"
      :table-title="tab_1.tableTitle1"
      :has-operation="true"
      :show-selection="false"
      :page-sizes="tab_1.page_sizes"
      :total-count="tab_1.total_count"
      :page-size="tab_1.page_sizes[0]"
      :table-operation="tab_1.tableOperation1"
      :conflict-operation="tab_1.conflictOperation1"
      :has-add-button="false"
      @operation-handle="operationHandle1"
      @change-page="change_page1"
      @size-change="size_change1"
    >
      <template slot="customcolumn" slot-scope="scope">
        <span
          v-if="scope.item.prop == 'publish'"
          :class="
            scope.row.publish === '1' || scope.row.publish === '2'
              ? 'sw-table-active'
              : scope.row.publish === 'closed' || scope.row.publish === '3'
              ? 'sw-table-closed'
              : scope.row.publish === '0'
              ? 'sw-table-unpublish'
              : 'sw-table-inactive'
          "
        >
          {{
            scope.row.publish === "0"
              ? "未发布"
              : scope.row.publish === "1" || scope.row.publish === "2"
              ? "已开启"
              : scope.row.publish === "closed" || scope.row.publish === "3"
              ? "已关闭"
              : "已过期"
          }}
        </span>
        <span v-else-if="scope.item.prop == 'version'">
          {{ scope.row.version }}
          <span
            v-if="scope.row.publish !== 'expired'"
            :class="{ 'bg-red': scope.row.publish === '0' }"
            class="remind-mes"
            ><span class="fs-10">{{
              scope.row.publish === "0" ? "最新" : "当前"
            }}</span></span
          >
        </span>
        <span
          v-else
          :title="scope.row[scope.item.prop] ? scope.row[scope.item.prop] : '-'"
          class="swTableCell"
        >
          {{ scope.row[scope.item.prop] ? scope.row[scope.item.prop] : "-" }}
        </span>
      </template>
    </sw-table>
    <sw-dialog
      :visible.sync="tab_1.show_ff_detail_edit"
      center
      append-to-body
      title="修改应用信息"
    >
      <el-form :model="tab_1.ff_detail">
        <el-form-item label="应用名称" label-width="90px">
          <el-input v-model="tab_1.ff_detail.ff_name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="应用描述" label-width="90px">
          <el-input
            v-model="tab_1.ff_detail.ff_describe"
            type="textarea"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item label="应用配图" label-width="90px">
          <el-upload
            :on-change="changeFile"
            :http-request="successUploadAppImg"
            class="avatar-uploader"
            :action="imgAction"
            :show-file-list="false"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <!-- <i class="el-icon-plus avatar-uploader-icon"/> -->
          </el-upload>
        </el-form-item>
        <el-form-item label="应用部门" label-width="90px">
          <el-cascader
            v-model="appForm.depId"
            :options="appForm.depOptions"
            :show-all-levels="false"
            :props="{ value: 'id', label: 'ins_name', checkStrictly: true }"
            filterable
          />
        </el-form-item>
        <el-form-item label="游客模式" label-width="90px">
          <el-switch
            v-model="appForm.visitor"
            active-value="1"
            inactive-value="0"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <div style="float: right; margin-bottom: 10px">
          <sw-button
            :loading="btn_update_loading"
            type="primary"
            :disabled="isDisabled"
            @click.stop="updateFFmanageById(tab_1.ff_detail)"
            >更新
          </sw-button>
          <sw-button simple @click.stop="tab_1.show_ff_detail_edit = false"
            >取消</sw-button
          >
        </div>
      </div>
    </sw-dialog>
    <sw-dialog
      :visible.sync="tab_1.show_ff_publish_panel"
      center
      append-to-body
      width="70%"
      title="发布说明"
    >
      <div class="fabu-dialog">
        <el-form :model="ff_publish" :rules="rules" style="overflow-x: hidden">
          <el-row
            style="margin-bottom: 10px; display: flex; align-items: center"
          >
            <el-col
              :span="1"
              class="font-grey font-important"
              style="align-self: flex-start"
              >发布说明：</el-col
            >
            <el-col :span="18">
              <el-input
                v-model.trim="ff_publish.des"
                :rows="4"
                placeholder="请输入发布说明(必填项目)"
                type="textarea"
                autocomplete="off"
              />
            </el-col>
          </el-row>
          <!-- <el-row
            style="margin-bottom: 10px; display: flex; align-items: center"
          >
            <el-col :span="1" class="font-grey">开放时间：</el-col>
            <el-col :span="12">
              <div class="cron">
                <el-popover v-model="cronPopover">
                  <cron
                    i18n="cn"
                    @change="changeCron"
                    @close="cronPopover = false"
                  />
                  <el-input
                    slot="reference"
                    v-model="ff_publish.data_limit"
                    placeholder="请选择开放时间"
                    @click="cronPopover = true"
                  />
                </el-popover>
              </div>

            </el-col>
          </el-row>
          <el-row
            style="margin-bottom: 10px; display: flex; align-items: center"
          >
            <el-col :span="1" class="font-grey">发起限定：</el-col>
            <el-col :span="3" style="margin-right: 5px">
              <el-input v-model.number="ff_publish.cycle" placeholder="周期" />
            </el-col>
            <el-col :span="3" style="margin-right: 20px">
              <el-select v-model="ff_publish.data_value" placeholder="请选择">
                <el-option
                  v-for="item in ff_publish.data_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-col>
            <el-col :span="3" style="display: flex; align-items: center">
              <sw-input
                v-model.number="ff_publish.zhouqi_number"
                placeholder="次数"
              />&nbsp;&nbsp;&nbsp;次
            </el-col>
          </el-row>
          <el-row
            style="margin-bottom: 10px; display: flex; align-items: center"
          >
            <el-col :span="1" class="font-grey">前置条件URL：</el-col>
            <el-col :span="16">
              <sw-input
                v-model="ff_publish.url"
                placeholder="请输入前置条件URL："
              />
            </el-col>
          </el-row>
          <el-row
            style="margin-bottom: 2px; display: flex; align-items: center"
          >
            <el-col :span="1" class="font-grey" />
            <el-col
              :span="18"
              style="color: rgba(132, 144, 154, 1); font-size: 12px"
            >
              例:${name}的服务
            </el-col>
          </el-row>
          <el-row
            style="margin-bottom: 10px; display: flex; align-items: center"
          >
            <el-col :span="1" class="font-grey">实例名称： </el-col>
            <el-col :span="16">
              <el-input
                v-model="ff_publish.instanceTitle"
                style="max-width: 80%"
                autocomplete="off"
              />
              <span
                style="color: #3394e1; cursor: pointer"
                @click="bdbl.visible = true"
                >表单变量查询</span
              >
            </el-col>
          </el-row>
          <el-row
            style="margin-bottom: 10px; display: flex; align-items: center"
          >
            <el-col :span="1" class="font-grey">推送事务中心： </el-col>
            <el-col :span="16">
              <el-switch
                v-model="ff_publish.pushTtc"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
                @change="handlePushTTCChange"
              >
              </el-switch>
            </el-col>
          </el-row>
          <el-row
            style="margin-bottom: 10px; display: flex; align-items: center"
          >
            <el-col :span="1" class="font-grey">是否使用新流程图： </el-col>
            <el-col :span="16">
              <el-switch
                v-model="ff_publish.newLowChart"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
                @change="handleNewLowChartChange"
              >
              </el-switch>
            </el-col>
          </el-row>
          <el-row
            style="margin-bottom: 10px; display: flex; align-items: center"
          >
            <el-col :span="1" class="font-grey">流程实例事务推送按钮：</el-col>
            <el-col :span="16">
              <el-checkbox
                true-label="1"
                false-label="0"
                v-model="ff_publish.termination"
                >终止</el-checkbox
              >
              <el-checkbox
                true-label="1"
                false-label="0"
                v-model="ff_publish.withdraw"
                >撤回</el-checkbox
              >
              <el-checkbox
                true-label="1"
                false-label="0"
                v-model="ff_publish.urge"
                >催办</el-checkbox
              >
            </el-col>
          </el-row>
          <el-row
            style="margin-bottom: 10px; display: flex; align-items: center"
          >
            <el-col :span="1" class="font-grey">审批状态显示：</el-col>
            <el-col :span="16">
              <el-switch
                v-model="ff_publish.showStatusInLookingPage"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
              >
              </el-switch>
            </el-col>
          </el-row>
          <transition name="slide-fade">
            <el-row
              style="margin-bottom: 10px; display: flex; align-items: center"
              v-if="ff_publish.showStatusInLookingPage === '1'"
            >
              <el-col :span="1" class="font-grey">状态颜色配置：</el-col>
              <el-col :span="16">
                <el-input
                  placeholder='例：{"同意":"green","审批中":"#E6A23C"}'
                  v-model="ff_publish.colorStatusInLookingPage"
                />
              </el-col>
            </el-row>
          </transition>
          <el-row
            style="margin-bottom: 10px; display: flex; align-items: center"
          >
            <el-col :span="1" class="font-grey"
              >附件水印（仅支持pdf文件）：</el-col
            >
            <el-col :span="16">
              <el-button type="text" @click="openWaterMark">去设置</el-button>
            </el-col>
          </el-row>
          <el-row
            style="margin-bottom: 10px; display: flex; align-items: flex-start"
          >
            <el-col :span="1" class="font-grey">查看页按钮配置： </el-col>
            <el-col :span="20">
              <el-row
                style="margin-bottom: 10px; display: flex; align-items: center"
              >
                <el-col :span="4"><span>流程图</span></el-col>
                <el-col :span="5">
                  <span style="margin-right: 10px">隐藏</span>
                  <el-switch
                    v-model="ff_publish.btnsConfig.flowsheetBtn.hide"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0"
                  ></el-switch>
                </el-col>
                <el-col :span="11">
                  <div style="display: flex; align-items: center">
                    <span style="margin-right: 10px">按钮重命名</span>
                    <el-input
                      style="flex: 1"
                      v-model.trim="ff_publish.btnsConfig.flowsheetBtn.newName"
                      placeholder="请填写"
                      size="medium"
                    ></el-input>
                  </div>
                </el-col>
              </el-row>
              <el-row
                style="margin-bottom: 10px; display: flex; align-items: center"
              >
                <el-col :span="4"><span>审批历史</span></el-col>
                <el-col :span="5">
                  <span style="margin-right: 10px">隐藏</span>
                  <el-switch
                    v-model="ff_publish.btnsConfig.approvalHistoryBtn.hide"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0"
                  ></el-switch>
                </el-col>
                <el-col :span="11">
                  <div style="display: flex; align-items: center">
                    <span style="margin-right: 10px">按钮重命名</span>
                    <el-input
                      style="flex: 1"
                      v-model.trim="
                        ff_publish.btnsConfig.approvalHistoryBtn.newName
                      "
                      placeholder="请填写"
                      size="medium"
                    ></el-input>
                  </div>
                </el-col>
              </el-row>
              <el-row
                style="
                  margin-bottom: 10px;
                  margin-top: 15px;
                  display: flex;
                  align-items: center;
                "
              >
                <el-col :span="4"><span>浏览器打印</span></el-col>
                <el-col :span="5">
                  <span style="margin-right: 10px">开启</span>
                  <el-switch
                    v-model="ff_publish.btnsConfig.approvalPrintBtn"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="1"
                    inactive-value="0"
                  ></el-switch>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row
            style="margin-bottom: 10px; display: flex; align-items: center"
          >
            <el-col :span="1" class="font-grey">办理须知组件：</el-col>
            <el-col :span="16">
              <el-checkbox v-model="needWarnInfo" />
            </el-col>
          </el-row>
          <el-row
            v-if="needWarnInfo"
            style="margin-bottom: 10px; display: flex; align-items: center"
          >
            <el-col :span="1" class="font-grey" />
            <el-col :span="16">
              <el-input
                v-model="warnInfo"
                placeholder="请输入办理须知组件名称"
              />
            </el-col>
          </el-row>
          <el-row
            style="margin-bottom: 10px; display: flex; align-items: center"
          >
            <el-col :span="1" class="font-grey" style="align-self: flex-start"
              >办事指南：</el-col
            >
            <el-col :span="18">
              <div class="edit_container" style="width: 100%">
                <quill-editor
                  ref="myQuillEditor"
                  v-model="ff_publish.editor_content"
                  :options="ff_publish.editorOption"
                  @ready="onEditorReady($event)"
                />

              </div>
            </el-col>
          </el-row> -->
        </el-form>
      </div>
      <div slot="footer">
        <div style="margin-bottom: 10px">
          <sw-button
            :loading="btn_fabu_loading"
            type="primary"
            @click.stop="publishSoft(ff_publish)"
            >确定</sw-button
          >
          <sw-button simple @click.stop="tab_1.show_ff_publish_panel = false"
            >取消</sw-button
          >
        </div>
      </div>
    </sw-dialog>
    <sw-dialog
      :visible.sync="bdbl.visible"
      append-to-body
      width="50%"
      center
      title="表单变量查询"
    >
      <sw-input
        v-model="bdbl.filterValue"
        placeholder="请输入筛选内容"
        prefix-icon="el-icon-search"
      />
      <ul
        v-loading="bdbl.loading"
        style="padding-left: 0px; overflow: auto; max-height: 300px"
      >
        <li
          v-for="(item, index) in bdblFilterList"
          :key="index"
          style="margin: 10px; display: flex; justify-content: space-between"
        >
          <span style="flex: 1">{{ item.name }}</span
          ><span style="flex: 1">{{ item.model }}</span>
        </li>
      </ul>
    </sw-dialog>
    <WaterMarkDialog
      v-if="waterMarkDialog"
      :waterMarkVisible.sync="waterMarkDialog"
      :wmfConfig="ff_publish.wmfConfig"
      :wmfOpt="wmfOpt"
      :blList="bdbl.list"
      @sendConfig="acceptConfig"
    ></WaterMarkDialog>
  </div>
</template>
<script>
import { encrypt } from "@/utils/crypto";
import { getCurDate } from "@/utils/index";
import service from "@/utils/service";
import { quillEditor } from "vue-quill-editor"; // 调用编辑器
// import VueUeditorWrap from 'vue-ueditor-wrap'
import cron from "./cron.vue"; // 调用cron表达式选择器
import WaterMarkDialog from "./components/WaterMarkDialog.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  filters: {
    format_time(sec) {
      const ft = new Date(sec);

      const y = ft.getFullYear();
      const m = ft.getMonth() + 1;
      const d = ft.getDate();
      const h = ft.getHours();
      const ms = ft.getMinutes();
      const s = ft.getSeconds();

      const formatNum = (num) => {
        if (num < 10) {
          return "0" + num;
        }
        return num;
      };

      return (
        y +
        "-" +
        formatNum(m) +
        "-" +
        formatNum(d) +
        " " +
        formatNum(h) +
        ":" +
        formatNum(ms) +
        ":" +
        formatNum(s)
      );
    },
  },
  components: {
    quillEditor,
    cron,
    WaterMarkDialog,
  },
  data() {
    return {
      needWarnInfo: false,
      warnInfo: "",
      ueditorConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        initialFrameHeight: 240,
        initialFrameWidth: "80%",
        serverUrl: "",
      },
      tab_1: {},
      action: "/api/v1/file/service/file-upload/upload",
      imgAction: "",
      timeStr: "",
      fileList: [],
      imageUrl: "",
      rules: {},
      ff_publish: {
        data_limit: "", // 有效期
        des: "", // 描述
        data_value: "", // 周期 显示内容
        data_options: "", // 周期 选择列表
        zhouqi_number: 0, // 周期 次数
        url: "",
        editor_content: "",
        editorOption: {},
        instanceTitle: "",
        pushTtc: "1",
        newLowChart: "0", // 是否使用新流程图
        termination: "1",
        withdraw: "1",
        urge: "1",
        showStatusInLookingPage: "",
        colorStatusInLookingPage: "",
        cycle: 0,
        // 水印表单内容
        wmfConfig: {
          content: "", // 水印内容
          dateChecked: false, // 是否添加下载日期
          fontFamily: "SimHei", // 字体
          fontSize: "32", // 字号
          fontColor: "", // 字体颜色
          opacity: 0.3, // 不透明度：0-1
          rotationAngle: 45, // 旋转角度：-180至180
          pageScale: 0.5, // 页面比例：0.1-2
          markNumber: 1, // 多行水印
          markNumChecked: false,
          // distance: '100', // 子项距离
          horizontalAlignment: {
            align: "center", // left center right
            alignNumber: 0,
            unit: "cm", // cm mm
          }, // 水平对齐
          verticalAlignment: {
            align: "center", // top center bottom
            alignNumber: 0,
            unit: "cm", // cm mm
          }, // 垂直对齐
        },
        // looking页流程图和审批历史按钮配置
        btnsConfig: {
          flowsheetBtn: {
            hide: false,
            newName: "",
          },
          approvalHistoryBtn: {
            hide: false,
            newName: "",
          },
        },
      },
      waterMarkDialog: false,
      wmfOpt: {
        fontFamilyOptions: [
          {
            label: "黑体",
            value: "SimHei",
          },
          {
            label: "宋体",
            value: "SimSun",
          },
        ],
        fontSizeOptions: [
          {
            label: "自动",
            value: "32",
          },
          {
            label: "36",
            value: "36",
          },
          {
            label: "40",
            value: "40",
          },
          {
            label: "44",
            value: "44",
          },
          {
            label: "48",
            value: "48",
          },
          {
            label: "52",
            value: "52",
          },
          {
            label: "56",
            value: "56",
          },
          {
            label: "60",
            value: "60",
          },
          {
            label: "64",
            value: "64",
          },
          {
            label: "68",
            value: "68",
          },
          {
            label: "72",
            value: "72",
          },
          {
            label: "76",
            value: "76",
          },
          {
            label: "80",
            value: "80",
          },
          {
            label: "84",
            value: "84",
          },
          {
            label: "88",
            value: "88",
          },
          {
            label: "92",
            value: "92",
          },
          {
            label: "96",
            value: "96",
          },
          {
            label: "100",
            value: "100",
          },
        ],
        rotationAngleOptions: [
          {
            label: "旋转45°",
            value: 45,
          },
          {
            label: "水平",
            value: 0,
          },
          {
            label: "旋转-45°",
            value: -45,
          },
          {
            label: "自定义",
            value: null,
          },
        ],
        markNumberOptions: [
          {
            label: "一页两行",
            value: 2,
          },
          {
            label: "一页三行",
            value: 3,
          },
          {
            label: "一页六行",
            value: 6,
          },
          {
            label: "一页八行",
            value: 8,
          },
          {
            label: "一页十二行",
            value: 12,
          },
        ],
        horizontalAlignmentOptions: [
          {
            label: "左对齐",
            value: "left",
          },
          {
            label: "居中",
            value: "center",
          },
          {
            label: "右对齐",
            value: "right",
          },
        ],
        verticalAlignmentOptions: [
          {
            label: "顶端对齐",
            value: "top",
          },
          {
            label: "居中",
            value: "center",
          },
          {
            label: "底端对齐",
            value: "bottom",
          },
        ],
        unitOptions: [
          {
            label: "厘米",
            value: "cm",
          },
          {
            label: "毫米",
            value: "mm",
          },
        ],
      },
      cronPopover: false,
      btn_update_loading: false,
      btn_fabu_loading: false,
      appForm: {
        depId: "",
        depOptions: [],
        visitor: "0",
      },
      bdbl: {
        list: [],
        visible: false,
        loading: false,
        filterValue: "",
      },
      isDisabled: false, // 防止提交按钮被连续多次点击
      timeout: null,
    };
  },
  computed: {
    bdblFilterList() {
      const filterArr = this.bdbl.list.filter((item) => {
        const str = item.name + "：" + item.model;
        return str.indexOf(this.bdbl.filterValue) > -1;
      });
      return filterArr;
    },
    table_size() {
      return this.$store.state.app.tableSize;
    },
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    fileBaseAPI() {
      return process.env.VUE_APP_FORM_FILE;
    },
  },
  watch: {
    // '$route.params.fid': function(newVal) {
    //   if (newVal) {
    //     this.getHistoryVersion(1, this.tab_1.pageSize)
    //   }
    // }
    "ff_publish.wmfConfig": {
      handler(val) {
        console.log("wmfConfig", val);
      },
      deep: true,
    },
  },
  created() {
    // 应用组id：this.$route.query.groupid
    const dir = getCurDate();
    this.timeStr = Date.now();
    const fileType = encrypt("", "formflow" + this.timeStr);
    this.imgAction =
      this.fileBaseAPI +
      this.action +
      "?appId=" +
      this.$route.query.groupid +
      "&dir=" +
      dir +
      "&fileType=" +
      encodeURIComponent(fileType);

    console.log("this.imgAction", this.imgAction);

    this.tab_1_init();
    this.$set(this.ff_publish, "data_options", [
      { label: "天", value: "day" },
      { label: "周", value: "week" },
      { label: "月", value: "month" },
      { label: "季度", value: "quarter" },
      { label: "年", value: "year" },
    ]);
    this.$set(this.ff_publish, "data_value", "");
    this.rules = {
      // data_limit: [{ required: false, message: '请选择有效期', trigger: 'blur' }],
      // des: [{ required: true, message: '请输入发布描述', trigger: 'blur' }],
      // data_value: [{ required: false, message: '请选择周期', trigger: 'blur' }],
      // url: [{ required: false, message: '请输入URL', trigger: 'blur' }],
    };
    this.getInstitution();
    this.getFormJson();
  },
  mounted() {},
  methods: {
    handlePushTTCChange(val) {
      if (val === "0") {
        this.$confirm("任务将不会推送事务中心！请确认是否关闭?", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).catch(() => {
          this.ff_publish.pushTtc = "1";
        });
      }
    },
    /**
     * 是否使用新流程图
     */
    handleNewLowChartChange(val) {
      if (val === "0") {
        this.$confirm("任务将不会使用新流程图！请确认是否关闭?", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        }).catch(() => {
          this.ff_publish.newLowChart = "1";
        });
      }
    },
    getInstitution() {
      service.get("/v1/institution/getInstitutionTreeData").then((res) => {
        this.appForm.depOptions = res;
      });
    },
    //
    onEditorReady(element) {},
    // 初始化数据
    tab_1_init() {
      this.$set(this.tab_1, "page_sizes", this.table_size);
      this.$set(this.tab_1, "pageSize", this.tab_1.page_sizes[0]);
      this.$set(this.tab_1, "total_count", 0);
      // tab1表头
      this.$set(this.tab_1, "tableTitle1", [
        { prop: "version", label: "版本号", width: "134", sortable: true },
        { prop: "ff_name", label: "应用名称", width: "200", sortable: true },
        {
          prop: "ff_describe",
          label: "应用描述",
          width: "346",
          sortable: true,
        },
        {
          prop: "create_time",
          label: "创建时间",
          width: "178",
          sortable: true,
        },
        { prop: "publish", label: "状态", width: "120", sortable: true },
      ]);
      // tab1操作
      this.$set(this.tab_1, "tableOperation1", [
        { name: "修改", icon: "su-icon-edit", operation: "edit" },
        { name: "开启", icon: "su-icon-right", operation: "start" },
        { name: "关闭", icon: "su-icon-pause", operation: "pause" },
        { name: "发布", icon: "su-icon-print", operation: "issue" },
      ]);
      // 状态2，3表示开启，关闭状态，且此时列表包含一个未发布应用
      this.$set(this.tab_1, "conflictOperation1", {
        pause: { prop: "publish", value: ["0", "closed", "expired", "3"] },
        start: { prop: "publish", value: ["0", "1", "expired", "2"] },
        issue: { prop: "publish", value: ["1", "closed", "expired", "2", "3"] },
        // edit: { prop: 'publish', value: ['expired', 'closed'] }
        edit: { prop: "publish", value: ["2", "3", "expired"] },
      });
      this.$set(this.tab_1, "show_ff_detail_edit", false);
      this.$set(this.tab_1, "ff_detail", { ff_name: "", ff_describe: "" });
      this.$set(this.tab_1, "ff_publish", { id: "", des: "" });
      this.getHistoryVersion(1, 10);
    },
    // 切换页面
    change_page1(page) {
      this.getHistoryVersion(page, this.tab_1.pageSize);
    },
    // 切换表格数据显示大小
    size_change1(size) {
      this.tab_1.pageSize = size;
      this.getHistoryVersion(1, this.tab_1.pageSize);
    },
    // 列表操作设置
    operationHandle1(id, operation) {
      if (this[`${operation}Handle1`]) {
        this[`${operation}Handle1`](id);
      }
    },
    // cron表达式改变
    changeCron(val) {
      this.ff_publish.data_limit = val;
    },
    // 获取历史版本列表
    getHistoryVersion(page, limit) {
      const param = {
        id: this.$route.params.fid,
        page: page,
        limit: limit,
      };
      service
        .get("v1/application/getHistoryVersion", { params: param })
        .then((res) => {
          if (!this.tab_1.total_count || res.count) {
            this.$set(this.tab_1, "total_count", res.count);
          }
          // res.data.forEach(d => {
          //   if (d.create_time) {
          //     d.create_time = this.$options.filters.format_time(d.create_time)
          //   }
          // })
          res.data.forEach((d) => {
            if (d.create_time) {
              d.create_time = this.$options.filters.format_time(d.create_time);
            }
            // 转变publish解决编辑操作的显示问题  2：开启状态（存在未发布应用）， 3：关闭状态（存在未发布应用）
            if (d.publish === "1" || d.publish === "closed") {
              var has = res.data.some((r) => {
                return r.publish === "0";
              });
              if (has) {
                d.publish = d.publish === "1" ? "2" : "3";
              }
            }
          });
          this.$set(this.tab_1, "tableData1", res.data);
          this.$set(this.tab_1, "ready", true);
        });
    },
    // 获取表单数据
    getFormJson() {
      this.bdbl.loading = true;
      service
        .get(`/v1/formflow/getNewFormInfoByFid?fid=${this.$route.params.fid}`)
        .then((res) => {
          if (res.moduleJson) {
            this.sonPages = res.moduleJson.sonPages;
            this.getInputModel(res.moduleJson.list);
            this.bdbl.loading = false;
          }
        })
        .catch((error) => {
          this.$swMessage({
            message: error.message,
            type: "error",
          });
          console.log(error);
        });
    },
    getInputModel(list, columns) {
      if (list && list.length) {
        list.forEach((item) => {
          this.bdbl.list.push({
            name: item.name,
            model: "${" + item.model + "}",
          });

          if (item.type === "page") {
            const page = this.sonPages[item.options.selectPage];
            if (page) {
              this.getInputModel(page.list, page.columns);
            }
          } else if (item.type === "sonform") {
            this.getInputModel(item.list, item.columns);
          } else if (item.type === "grid") {
            this.getInputModel(item.list, item.columns);
          } else if (item.type === "comment") {
            this.getInputModel(item.list, item.columns);
          }
        });
      }
      if (columns && columns.length) {
        columns.forEach((item) => {
          this.getInputModel(item.list, item.columns);
        });
      }
    },
    // 页面刷新
    reset() {
      this.tab_1.ready = false;
      this.getHistoryVersion(1, this.tab_1.pageSize);
    },
    // 应用管理--关闭操作
    pauseHandle1(id) {
      var param = {
        id: id,
      };
      var num = -1;
      this.tab_1.tableData1.some((d, index) => {
        if (d.id === id) {
          num = index;
          return true;
        }
      });
      if (
        this.tab_1.tableData1[num].publish === "1" ||
        this.tab_1.tableData1[num].publish === "2"
      ) {
        param.publish = "closed";
      } else {
        return;
      }
      service.post("/v1/application/closePublish", param).then((res) => {
        this.reset();
        this.$swMessage({
          message: `${this.tab_1.tableData1[num].ff_name}关闭成功`,
          type: "success",
        });
      });
    },
    // 应用管理--开启操作
    startHandle1(id) {
      var param = {
        id: id,
        publish: "1",
      };
      var num = -1;
      this.tab_1.tableData1.some((d, index) => {
        if (d.id === id) {
          num = index;
          return true;
        }
      });
      service.post("/v1/application/openPublish", param).then((res) => {
        this.reset();
        this.$swMessage({
          message: `${this.tab_1.tableData1[num].ff_name}开启成功`,
          type: "success",
        });
      });
    },
    // 应用管理--发布操作
    issueHandle1(id) {
      this.ff_publish.data_limit = ""; // 有效期
      this.ff_publish.des = ""; // 描述
      this.ff_publish.data_value = ""; // 周期 显示内容
      this.ff_publish.zhouqi_number = 0; // 周期 次数
      this.ff_publish.url = "";
      this.ff_publish.editor_content = "";
      this.ff_publish.editorOption = {};
      this.ff_publish.id = id;
      var param = {};
      var softNow = {};
      this.tab_1.tableData1.some((d, index) => {
        if (d.id === id) {
          softNow = d;
          param.form_id = d.form_id;
          param.version = d.form_version;
          return true;
        }
      });
      if (!softNow.deployId) {
        this.$swMessage({
          message: "该应用下流程未发布,请发布流程后重试",
          type: "error",
        });
        return;
      }
      service
        .get("/v1/application/getFormStatus", { params: param })
        .then((res) => {
          if (res.data === "1") {
            return this.getLatestPublish();
          } else {
            this.$swMessage({
              message: "该应用下表单未发布,请发布表单后重试",
              type: "error",
            });
          }
        })
        .then((res) => {
          if (!res.data) {
            this.$set(this.tab_1, "show_ff_publish_panel", true);
            return;
          }
          this.ff_publish.instanceTitle = this.$store.getters.appInfo.ff_name;
          this.ff_publish.data_limit = res.data.cron ? res.data.cron : ""; // 有效期
          this.ff_publish.des = res.data.reMark; // 描述
          this.ff_publish.data_value = res.data.type ? res.data.type : ""; // 周期 显示内容
          this.ff_publish.cycle = res.data.cycle ? res.data.cycle : ""; // 周期 显示内容
          this.ff_publish.zhouqi_number = res.data.amount; // 周期 次数
          this.ff_publish.url = res.data.precondition
            ? res.data.precondition
            : "";
          this.ff_publish.editor_content = res.data.guide ? res.data.guide : "";
          this.ff_publish.instanceTitle =
            res.data.instanceTitle || this.ff_publish.instanceTitle;
          this.ff_publish.pushTtc = res.data.pushTtc || "1";
          this.ff_publish.newLowChart = res.data.newLowChart || "0";
          this.ff_publish.termination = res.data.termination || "1";
          this.ff_publish.withdraw = res.data.withdraw || "1";
          this.ff_publish.urge = res.data.urge || "1";
          this.ff_publish.showStatusInLookingPage =
            res.data.showStatusInLookingPage || "0";
          this.ff_publish.colorStatusInLookingPage =
            res.data.colorStatusInLookingPage || "";
          if (res.data.watermarkConfiguration) {
            this.ff_publish.wmfConfig = res.data.watermarkConfiguration;
          }
          if (res.data.btnsConfig) {
            this.ff_publish.btnsConfig = JSON.parse(res.data.btnsConfig);
          }
          this.$set(this.tab_1, "show_ff_publish_panel", true);
        })
        .catch((err) => {
          console.log(err);
          // this.$swMessage({
          //   message: err,
          //   type: 'error'
          // })
        });
    },
    // 获取应用最近一次的发布信息
    getLatestPublish() {
      return service.get(
        `/v1/application/getNewPublishContent?fid=${this.$route.params.fid}`
      );
    },
    // 发布应用
    publishSoft(detail) {
      // 判断开放时间cron表达式关于年份位置是否正确
      if (detail.data_limit) {
        const _date = detail.data_limit.split(" ");
        if (_date.length > 1) {
          const year = _date[_date.length - 1].split("-");
          if (year.length === 2) {
            if (year[0] > year[1]) {
              this.$swMessage({
                message: "开放时间设置错误",
                type: "error",
              });
              return;
            }
          }
        }
      }
      if (!detail.des.length) {
        this.$swMessage({
          message: "发布说明不能为空",
          type: "error",
        });
        return;
      }
      var param = {
        fid: detail.id,
        reMark: detail.des,
        // guide: `${this.ff_publish.editor_content}`,
        // cron: detail.data_limit,
        // startTime: detail.data_limit[0],
        // endTime: detail.data_limit[1],
        // cycle: detail.data_value,
        // amount: detail.zhouqi_number,
        // precondition: detail.url,
        // warnInfo: this.warnInfo
      };
      if (this.ff_publish.editor_content) {
        param.guide = `${this.ff_publish.editor_content}`;
      }
      if (detail.data_limit) {
        param.cron = detail.data_limit;
      }
      if (detail.zhouqi_number) {
        param.amount = detail.zhouqi_number;
      }
      if (detail.url) {
        param.precondition = detail.url;
      }
      if (detail.warnInfo) {
        param.warnInfo = detail.warnInfo;
      }
      if (detail.cycle) {
        if (detail.cycle) {
          param.cycle = detail.cycle;
        }
        if (detail.data_value) {
          param.type = detail.data_value;
        }
      }
      var num = -1;
      this.tab_1.tableData1.some((d, index) => {
        if (d.id === detail.id) {
          num = index;
          return true;
        }
      });
      if (this.tab_1.tableData1[num].publish === "0") {
        param.ifpublish = 1;
      } else {
        return;
      }
      param.instanceTitle = this.ff_publish.instanceTitle;
      param.pushTtc = this.ff_publish.pushTtc;
      param.newLowChart = this.ff_publish.newLowChart;
      param.termination = this.ff_publish.termination;
      param.withdraw = this.ff_publish.withdraw;
      param.urge = this.ff_publish.urge;
      param.showStatusInLookingPage = this.ff_publish.showStatusInLookingPage;
      param.watermarkConfiguration = JSON.stringify(this.ff_publish.wmfConfig);
      param.btnsConfig = JSON.stringify(this.ff_publish.btnsConfig);

      if (
        param.showStatusInLookingPage === "1" &&
        this.ff_publish.colorStatusInLookingPage.length
      ) {
        try {
          param.colorStatusInLookingPage = JSON.stringify(
            JSON.parse(this.ff_publish.colorStatusInLookingPage)
          );
        } catch (error) {
          this.$swMessage({
            message: "状态颜色配置不符合json格式",
            type: "error",
          });
          return;
        }
      }

      this.btn_fabu_loading = true;
      service
        .post("/v1/application/changePublish", param)
        .then((res) => {
          this.reset();
          this.tab_1.show_ff_publish_panel = false;
          this.btn_fabu_loading = false;
          this.$swMessage({
            message: `${this.tab_1.tableData1[num].ff_name}发布成功`,
            type: "success",
          });
        })
        .catch((err) => {
          this.$swMessage({
            message: err.message,
            type: "error",
          });
        });
    },
    // 应用管理--编辑应用详情
    editHandle1(id) {
      // eslint-disable-next-line no-unused-vars
      var num = -1;
      this.tab_1.tableData1.some((d, index) => {
        if (d.id === id) {
          num = index;
          this.tab_1.ff_detail.id = id;
          this.tab_1.ff_detail.ff_name = d.ff_name;
          this.tab_1.ff_detail.ff_describe = d.ff_describe;
          this.tab_1.ff_detail.ff_logo = d.logo;
          this.appForm.visitor = d.visitor;
          this.appForm.depId = d.dept_id;
          return true;
        }
      });
      this.imageUrl = this.$store.getters.appInfo.logo;
      this.$set(this.tab_1, "show_ff_detail_edit", true);
    },
    // handleFileUploaderChange(file) {
    //   const is50kb = file.size <= 50 * 1024 // 限制小于50kb
    //   if (!is50kb) {
    //     this.$swMessage({
    //       message: `图片大小限制为50kb,该图片尺寸为${(file.size / 1024).toFixed(
    //         2
    //       )}kb`,
    //       type: 'error'
    //     })
    //     this.imageUrl = this.$store.getters.appInfo.logo
    //     return
    //   }
    //   const _this = this
    //   const reader = new FileReader()
    //   reader.readAsDataURL(file.raw)
    //   reader.onload = function (event) {
    //     const imgBase64 = this.result
    //     _this.imageUrl = imgBase64
    //   }
    // },

    successUploadAppImg() {
      if (this.fileList[0] && this.fileList[0].raw) {
        let file = this.fileList[0].raw;
        console.log("file", file);
        this.uploadAction(file);
      }
    },
    uploadAction(file) {
      const xhr = new XMLHttpRequest();
      const url = this.imgAction;
      xhr.open("POST", url, true);
      const token = localStorage.getItem("Admin-Token");
      xhr.setRequestHeader("X-Id-Token", token);
      const visitor = sessionStorage.getItem("visitor");
      xhr.setRequestHeader("visitor", visitor);
      xhr.setRequestHeader("timeStr", this.timeStr);
      const formData = new FormData();
      formData.append("file", file);
      xhr.send(formData);
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const resData = JSON.parse(xhr.response);
          if (
            resData &&
            resData.status === 200 &&
            resData.data &&
            resData.data.id
          ) {
            this.$set(this.fileList, 0, {
              ...this.fileList[0],
              id: resData.data.id,
              name: file.name,
              url:
                this.fileBaseAPI +
                "/api/v1/file/service/file-upload/view-img?id=" +
                resData.data.id,
              percentage: 100,
            });
            setTimeout(() => {
              this.fileList[0] = { ...this.fileList[0], status: "success" };
              this.imageUrl = this.fileList[0].url;
            }, 200);
          } else {
            this.$swMessage.error("图片上传失败," + resData.message, true);
            this.fileList = [];
            // 若上传失败还使用原来的图片
            this.imageUrl = this.$store.getters.appInfo.logo;
          }
        }
        console.log("this.fileList", this.fileList);
      };
    },
    changeFile(file, fileList) {
      const is50kb = file.size <= 50 * 1024; // 限制小于50kb
      if (!is50kb) {
        this.$swMessage({
          message: `图片大小限制为50kb,该图片尺寸为${(file.size / 1024).toFixed(
            2
          )}kb`,
          type: "error",
        });

        if (
          !fileList[fileList.length - 1].url &&
          fileList[fileList.length - 1].status !== "success"
        ) {
          fileList.splice(fileList.length - 1, 1);
        }
        this.fileList = fileList;
        return;
      }

      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      this.fileList = fileList;
      console.log("this.fileList ", this.fileList);
    },
    updateFFmanageById(detail) {
      // 检测空字符串
      if (
        !detail.ff_name ||
        detail.ff_name.replace(/(^\s*)|(\s*$)/g, "").length === 0
      ) {
        this.$swMessage({
          message: "应用名称不能为空",
          type: "error",
        });
        return;
      }
      if (
        !detail.ff_describe ||
        detail.ff_describe.replace(/(^\s*)|(\s*$)/g, "").length === 0
      ) {
        this.$swMessage({
          message: "应用描述不能为空",
          type: "error",
        });
        return;
      }

      this.isDisabled = true;
      this.timeout = setTimeout(() => {
        this.isDisabled = false;
      }, 3000);

      var param = detail;
      param.logo = this.imageUrl;
      param.dept_id = this.appForm.depId;
      param.visitor = this.appForm.visitor;
      this.btn_update_loading = true;
      service
        .post("v1/application/updateFFmanageById", param)
        .then((res) => {
          this.btn_update_loading = false;
          this.getHistoryVersion(1, this.tab_1.pageSize);
          this.tab_1.show_ff_detail_edit = false;
          const appInfo = this.$store.getters.appInfo;
          appInfo.ff_name = param.ff_name;
          appInfo.ff_describe = param.ff_describe;
          appInfo.logo = param.logo;
          this.$store.commit("SET_APPINFO", appInfo);
          this.$swMessage({
            message: `修改信息成功`,
            type: "success",
          });
        })
        .catch((err) => {
          this.$swMessage({
            message: err.message,
            type: "error",
          });
        });
    },
    // 水印
    openWaterMark() {
      this.waterMarkDialog = true;
    },
    acceptConfig(val) {
      this.ff_publish.wmfConfig = val;
    },
  },
  beforeDestroy() {
    // clear the timeout before the component is destroyed
    clearTimeout(this.timeout);
  },
};
</script>
<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 70px;
  line-height: 70px !important;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 70px;
  display: block;
}

.el-upload:hover {
  .avatar {
    filter: brightness(0.5);
  }
}

.sw-table-unpublish {
  font-size: 12px;
  color: #f5a623;
  line-height: 22px;

  &:before {
    width: 8px;
    height: 8px;
    background: #f5a623;
    border-radius: 4px;
    display: inline-block;
    content: "";
  }
}

.sw-table-closed {
  font-size: 12px;
  color: rgba(238, 84, 79, 1);
  line-height: 22px;

  &:before {
    width: 8px;
    height: 8px;
    background: rgba(238, 84, 79, 1);
    border-radius: 4px;
    display: inline-block;
    content: "";
  }
}

.remind-mes {
  display: inline-block;
  width: 30px !important;
  height: 14px !important;
  line-height: 14px;
  text-align: center;
  margin-left: 8px;
  white-space: nowrap;
  background: rgba(51, 148, 225, 1);
  color: rgba(255, 255, 255, 1);
  border-radius: 0px 26px 26px 0px;
}

.fs-10 {
  display: inline-block;
  font-size: 10px;
  -webkit-font-size: 12px;
  -webkit-transform: scale(0.8);
}

.bg-red {
  background: rgba(238, 84, 79, 1);
}

.fabu-dialog {
  overflow-y: scroll !important;
  max-height: calc(100vh - 200px) !important;
}

.font-grey {
  color: rgba(132, 144, 154, 1);
  font-size: 12px;
  width: 155px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  white-space: nowrap;
  text-align: right;
  padding-right: 20px;
}

.font-important {
  &:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
</style>
<style lang="scss">
.el-popover {
  .el-tabs--border-card > .el-tabs__content {
    max-height: 300px;
    overflow: auto;
  }
}
</style>
